<template>
  <section class="section" id="container-demo" v-if="frsm">
    <!-- Title -->
    <div style="margin-bottom: 40px" class="is-flex is-justify-center">
      <hr class="has-text-dark" style="width: 20%" />
      <h1
        class="title is-size-4"
        style="margin-top: 10px; margin-right: 15px; margin-left: 15px"
      >
        Demográficos
        {{ !header.cantDemo ? " - No hay demográficos disponibles" : "" }}
      </h1>
      <hr class="has-text-dark" style="width: 20%" />
    </div>

    <!-- Buttons -->
    <div style="margin-bottom: 10px" class="button-menu">
      <a class="button is-link" v-on:click="showMenu">Listar gráficas</a>
    </div>

    <!-- Container of Graphs -->
    <div class="columns is-multiline">
      <div
        v-for="(d, k) in getDemo()"
        :key="k"
        :id="`Grafica-${k}`"
        class="column is-6"
      >
        <div class="box">
          <div
            style="width: 100%; margin-bottom: 10px !important;"
            class="has-text-centered subtitle is-capitalized"
          >
            <nav class="level is-flex">
              <div
                class="level-item has-text-left"
                style="width: 66% !important;"
              >
                <div style="width: 100%;" id="title-var-Graph">
                  <p class="has-text-weight-bold is-size-4 truncate">
                    {{ getNameDem(k) }}
                  </p>
                </div>
              </div>
              <div
                class="level-item has-text-centered"
                style="margin-bottom: 0 !important;"
              >
                <div>
                  <p class="heading">Elementos</p>
                  <p class="has-text-weight-bold">{{ getElements(d) }}</p>
                </div>
              </div>
              <div
                class="level-item has-text-centered"
                style="margin-bottom: 0 !important;"
              >
                <div>
                  <p class="heading">Ver más</p>
                  <p>
                    <i
                      class="material-icons is-size-5"
                      style="cursor: pointer;"
                      v-on:click="showTable(k)"
                      >{{
                        k === activeTable ? "visibility_off" : "visibility"
                      }}</i
                    >
                  </p>
                </div>
              </div>
            </nav>
          </div>
          <hr style="margin-top: 10px !important;" />
          <div class="is-flex" style="justify-content: space-between">
            <div style="width: 35%; height: 160px">
              <y-graph :datagraph="createDataGraphDona(d)"></y-graph>
            </div>
            <div style="width: 60%; height: 160px">
              <y-graph :datagraph="createDataGraphHorizontalBar(d)"></y-graph>
            </div>
          </div>
          <br />
          <hr style="margin-top: 10px !important;" v-if="k === activeTable" />
          <div v-if="k === activeTable">
            <table-demo :data="getDataTable(d)"></table-demo>
          </div>
        </div>
        <br />
      </div>
    </div>

    <!-- Menu Select Graphs -->
    <transition name="slide">
      <menu-graphs-demo
        v-if="showMenuG"
        :data="getDemo()"
        @showMenu="showMenu"
        @selectGraph="selectGraph"
      ></menu-graphs-demo>
    </transition>
  </section>
</template>
<script>
import yGraph from "@/components/dashboard/GraphFrs.vue";
import menuGraphsDemo from "./components/menuGraphsDemo.vue";
import tableDemo from "./components/tableDemo.vue";
export default {
  data() {
    return {
      dona: {
        data: {
          labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
          datasets: [
            {
              data: [12, 19, 3, 5, 2, 3],
              backgroundColor: [
                "#f4cdcd",
                "#facca5",
                "#fff2cc",
                "#d9ead3",
                "#a2c4c9",
                "#c8d9f7",
                "#a9d0ef",
                "#e8d2f5",
                "#e7c2e1",
                "#c2e7e7",
                "#fab9a5",
              ],
              borderColor: [
                "#f6adad",
                "#f6b884",
                "#f6db8a",
                "#c3eab5",
                "#88c1cb",
                "#a8c2ef",
                "#95c5ec",
                "#deb8f3",
                "#efb4e5",
                "#bbf5f5",
                "#f5a992",
              ],
              borderWidth: 1,
            },
          ],
        },
        /* "colors": [
          "#bebdbd",
          "#f4cdcd",
          "#facca5",
          "#fff2cc",
          "#d9ead3",
          "#a2c4c9",
          "#c8d9f7"
        ], */
        options: {
          legend: {
            display: true,
            position: "right",
          },
          responsive: true,
          resizeDelay: 0,
          plugins: {
            datalabels: {
              formatter: function(value, context) {
                return `${value}%`;
              },
              color: "white",
              font: {
                weight: "bold",
              },
            },
          },
        },
        type: "pie",
      },
      horizontalBar: {
        type: "horizontalBar",
        options: {
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
            },
          },
          hover: {
            animationDuration: 0,
          },
          tooltips: {
            enabled: false,
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  display: false,
                },
                scaleLabel: {
                  display: false,
                },
                gridLines: {
                  display: false,
                },
                stacked: true,
              },
            ],
            yAxes: [
              {
                gridLines: {
                  display: false,
                },
                ticks: {
                  display: false,
                  beginAtZero: true,
                  max: 100,
                },
                stacked: true,
              },
            ],
          },
          legend: {
            position: "top",
            display: false,
          },
          animate: {},
          pointLabelFontFamily: "Quadon Extra Bold",
          scaleFontFamily: "Quadon Extra Bold",
          responsive: true,
          resizeDelay: 0,
          plugins: {
            datalabels: {
              formatter: function(value, context) {
                return `${value}%`;
              },
              textAlign: "start",
            },
          },
        },
        data: {
          labels: ["Data 1"],
          datasets: [
            {
              label: "Dataset 1",
              data: [28],
              backgroundColor: ["#f4cdcd"],
            },
            {
              label: "Dataset 2",
              data: [45.7],
              backgroundColor: ["#facca5"],
            },
            {
              label: "Dataset 3",
              data: [65.9],
              backgroundColor: ["#fff2cc"],
            },
            {
              label: "Dataset 4",
              data: [72.4],
              backgroundColor: ["#d9ead3"],
            },
            {
              label: "Dataset 5",
              data: [32],
              backgroundColor: ["#c8d9f7"],
            },
          ],
        },
      },
      colors: [
        "#e7c2e1",
        "#d9ead3",
        "#a9d0ef",
        "#c2e7e7",
        "#fab9a5",
        "#a2c4c9",
      ],
      header: {
        cantDemo: 0,
        select: "",
      },
      activeTable: "",
      showMenuG: false,
    };
  },
  props: {
    frsm: Object,
  },
  beforeMount() {
    // Get cantDemo
    let demo = this.getDemo();
    this.header.cantDemo = Object.keys(demo).length;
  },
  methods: {
    // Graphs
    createDataGraphDona(data) {
      if (data) {
        data = this.sortData(data, true);
        let labels = data.map((e) => e.SubGrupo);

        const dataDona = {
          data: {
            labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
            datasets: [
              {
                data: [12, 19, 3, 5, 2, 3],
                backgroundColor: [
                  "#e7c2e1",
                  "#d9ead3",
                  "#a9d0ef",
                  "#c2e7e7",
                  "#fab9a5",
                  "#a2c4c9",
                ],
                borderColor: [
                  "#e5a9db",
                  "#bde0b1",
                  "#8cbee5",
                  "#a3e0e0",
                  "#fab9a5",
                  "#8ebec5",
                ],
                borderWidth: 1,
              },
            ],
          },
          options: {
            layout: {
              margin: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
              },
            },
            tooltips: {
              enabled: false,
              custom: function(tooltipModel) {
                // Tooltip Element
                let tooltipEl = document.getElementById(
                  "chartjs-tooltip-dona-frp"
                );

                // Create element on first render
                if (!tooltipEl) {
                  tooltipEl = document.createElement("div");
                  tooltipEl.id = "chartjs-tooltip-dona-frp";
                  tooltipEl.innerHTML = "<table></table>";
                  tooltipEl.style.backgroundColor = "rgba(0,0,0,0.71)";
                  tooltipEl.style.borderRadius = "5%";
                  document.body.appendChild(tooltipEl);
                }

                // Hide if no tooltip
                if (tooltipModel.opacity === 0) {
                  tooltipEl.style.opacity = 0;
                  return;
                }

                // Set caret Position
                tooltipEl.classList.remove("above", "below", "no-transform");
                if (tooltipModel.yAlign) {
                  tooltipEl.classList.add(tooltipModel.yAlign);
                } else {
                  tooltipEl.classList.add("no-transform");
                }

                function getBody(bodyItem) {
                  return bodyItem.lines;
                }

                // Set Text
                if (tooltipModel.body) {
                  let titleLines = tooltipModel.title || [];
                  let bodyLines = tooltipModel.body.map(getBody);

                  let innerHtml = "<thead>";

                  titleLines.forEach(function(title) {
                    innerHtml +=
                      '<tr><th style="color: white;">' + title + "</th></tr>";
                  });
                  innerHtml += "</thead><tbody>";

                  bodyLines.forEach(function(body, i) {
                    let colors = tooltipModel.labelColors[i];
                    let style = "background:" + colors.backgroundColor;
                    style += "; border-color:" + colors.borderColor;
                    style += "; border-width: 2px";
                    let span = '<span style="' + style + '"></span>';
                    innerHtml +=
                      '<tr><td style="color: white;">' +
                      span +
                      body +
                      "%" +
                      "</td></tr>";
                  });
                  innerHtml += "</tbody>";

                  let tableRoot = tooltipEl.querySelector("table");
                  tableRoot.innerHTML = innerHtml;
                }

                // `this` will be the overall tooltip
                let position = this._chart.canvas.getBoundingClientRect();

                // Display, position, and set styles for font
                tooltipEl.style.opacity = 1;
                tooltipEl.style.position = "absolute";
                tooltipEl.style.left =
                  position.left +
                  window.pageXOffset +
                  tooltipModel.caretX +
                  "px";
                tooltipEl.style.top =
                  position.top +
                  window.pageYOffset +
                  tooltipModel.caretY +
                  "px";
                tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                tooltipEl.style.fontSize = tooltipModel.bodyFontSize + "px";
                tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                tooltipEl.style.padding =
                  tooltipModel.yPadding + "px " + tooltipModel.xPadding + "px";
                tooltipEl.style.pointerEvents = "none";
              },
            },
            legend: {
              display: false,
              position: "right",
            },
            responsive: true,
            resizeDelay: 0,
            plugins: {
              datalabels: {
                formatter: function(value, context) {
                  if (parseInt(value) > 5) {
                    return `${value}%`;
                  }
                  return "";
                },
                // color: 'grey',
                // font: {
                //  weight: 'bold'
                // }
              },
            },
          },
          type: "pie",
        };

        dataDona.data.labels = this.setLabelsDona(
          labels.filter((x) => {
            if (x) return true;
          })
        );
        dataDona.data.datasets[0].data = this.setDatasetsDona(data);

        return dataDona;
      }
      return this.dona;
    },
    createDataGraphHorizontalBar: function(data) {
      if (data) {
        data = this.sortData(data, true);
        const labels = data.map((e) => e.SubGrupo);

        const dataHorizontalBar = {
          type: "horizontalBar",
          options: {
            layout: {
              padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
              },
              margin: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
              },
            },
            hover: {
              animationDuration: 0,
            },
            tooltips: {
              enabled: false,
              custom: function(tooltipModel) {
                // Tooltip Element
                let tooltipEl = document.getElementById(
                  "chartjs-tooltip-bar-frp"
                );

                // Create element on first render
                if (!tooltipEl) {
                  tooltipEl = document.createElement("div");
                  tooltipEl.id = "chartjs-tooltip-bar-frp";
                  tooltipEl.innerHTML = "<table></table>";
                  tooltipEl.style.backgroundColor = "rgba(0,0,0,0.71)";
                  tooltipEl.style.borderRadius = "5%";
                  document.body.appendChild(tooltipEl);
                }

                // Hide if no tooltip
                if (tooltipModel.opacity === 0) {
                  tooltipEl.style.opacity = 0;
                  return;
                }

                // Set caret Position
                tooltipEl.classList.remove("above", "below", "no-transform");
                if (tooltipModel.yAlign) {
                  tooltipEl.classList.add(tooltipModel.yAlign);
                } else {
                  tooltipEl.classList.add("no-transform");
                }

                function getBody(bodyItem) {
                  return bodyItem.lines;
                }

                // Set Text
                if (tooltipModel.body) {
                  let titleLines = tooltipModel.title || [];
                  let bodyLines = tooltipModel.body.map(getBody);

                  let innerHtml = "<thead>";

                  titleLines.forEach(function(title) {
                    innerHtml +=
                      '<tr><th style="color: white;">' + title + "</th></tr>";
                  });
                  innerHtml += "</thead><tbody>";

                  bodyLines.forEach(function(body, i) {
                    let colors = tooltipModel.labelColors[i];
                    let style = "background:" + colors.backgroundColor;
                    style += "; border-color:" + colors.borderColor;
                    style += "; border-width: 2px";
                    let span = '<span style="' + style + '"></span>';
                    innerHtml +=
                      '<tr><td style="color: white;">' +
                      span +
                      body +
                      "</td></tr>";
                  });
                  innerHtml += "</tbody>";

                  let tableRoot = tooltipEl.querySelector("table");
                  tableRoot.innerHTML = innerHtml;
                }

                // `this` will be the overall tooltip
                let position = this._chart.canvas.getBoundingClientRect();

                // Display, position, and set styles for font
                tooltipEl.style.opacity = 1;
                tooltipEl.style.position = "absolute";
                tooltipEl.style.left =
                  position.left +
                  window.pageXOffset +
                  tooltipModel.caretX +
                  "px";
                tooltipEl.style.top =
                  position.top +
                  window.pageYOffset +
                  tooltipModel.caretY +
                  "px";
                tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                tooltipEl.style.fontSize = tooltipModel.bodyFontSize + "px";
                tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                tooltipEl.style.padding =
                  tooltipModel.yPadding + "px " + tooltipModel.xPadding + "px";
                tooltipEl.style.pointerEvents = "none";
              },
            },
            scales: {
              xAxes: [
                {
                  ticks: {
                    display: true,
                    beginAtZero: true,
                    max: 100,
                    stepSize: 20, // Establecer el incremento deseado
                  },
                  scaleLabel: {
                    display: false,
                  },
                  gridLines: {
                    display: true,
                  },
                  stacked: false,
                },
              ],
              yAxes: [
                {
                  gridLines: {
                    display: false,
                  },
                  ticks: {
                    display: true,
                    callback: function(value, index, values) {
                      const maxLabelLength = 20; // Número máximo de caracteres permitidos
                      if (value.length > maxLabelLength) {
                        return value.substring(0, maxLabelLength) + "...";
                      }
                      return value;
                    },
                  },
                  stacked: false,
                },
              ],
            },
            legend: {
              position: "top",
              display: false,
            },
            animate: {},
            pointLabelFontFamily: "Quadon Extra Bold",
            scaleFontFamily: "Quadon Extra Bold",
            responsive: true,
            resizeDelay: 0,
          },
          data: {
            labels: ["Datos1", "Datos2", "Datos3", "Datos4"],
            datasets: [
              {
                label: "Dataset 1",
                data: [28, 23, 42, 53],
                backgroundColor: ["#f4cdcd"],
              },
            ],
          },
        };

        const dataSets = this.setDataBar(data);

        dataHorizontalBar.data.labels = this.setLabelBar(
          labels.filter((x) => {
            if (x) return true;
          })
        );
        dataHorizontalBar.data.datasets = [
          {
            label: "N",
            data: dataSets,
            backgroundColor: [
              "#e7c2e1",
              "#d9ead3",
              "#a9d0ef",
              "#c2e7e7",
              "#fab9a5",
              "#a2c4c9",
            ],
            borderColor: [
              "#e5a9db",
              "#bde0b1",
              "#8cbee5",
              "#a3e0e0",
              "#fab9a5",
              "#8ebec5",
            ],
            borderWidth: 1,
          },
        ];

        dataHorizontalBar.options.scales.xAxes[0].ticks.max = this.getDataMax(
          dataSets
        );

        return dataHorizontalBar;
      }
      return this.horizontalBar;
    },
    // Helpers
    getDemo() {
      return Object.keys(this.frsm["dataAdmin"]).reduce((resultado, key) => {
        if (key.includes("DEM-")) {
          resultado[key] = this.frsm["dataAdmin"][key];
        }
        return resultado;
      }, {});
    },
    getNameDem(data) {
      return data.split("-")[2];
    },
    getElements(data) {
      return Object.keys(data.filter((x) => x.SubGrupo)).length;
    },
    getDataMax(data) {
      const numberMax = Math.max(...data);
      return Math.ceil(numberMax / 5) * 5;
    },
    sortData(data, object = false) {
      if (data) {
        if (object) {
          data = data.filter((e) => {
            if (e.SubGrupo) {
              return true;
            }
            return false;
          });
          return data.slice().sort(function(a, b) {
            let numA, numB;

            numA = parseFloat(a["countData"]["sum"]);
            numB = parseFloat(b["countData"]["sum"]);

            return numB - numA; // Orden descendente
          });
        }
        if (data.every((item) => !isNaN(item["countData"]["sum"]))) {
          return data.slice().sort((a, b) => b - a);
        }
        return data.slice().sort();
      }
      return data;
    },
    setDatasetsDona(data) {
      // Get sum all data
      const sumData = data
        .map((x) => {
          if (x.SubGrupo) return x["countData"]["sum"];
          return 0;
        })
        .reduce((a, b) => a + b, 0);

      // Filter and calculate data
      let dataSets = data
        .filter((x) => {
          if (x.SubGrupo) return true;
        })
        .map((x) => {
          return ((x["countData"]["sum"] * 100) / sumData).toFixed(1);
        });

      if (dataSets.length > 5) {
        // The elements from position 5 onwards are added together
        const startIndex = 5;
        const sumOfElements = dataSets
          .slice(startIndex)
          .reduce((a, b) => +a + +b, 0);
        // Set data
        dataSets = dataSets.slice(0, 5);
        dataSets.push(sumOfElements.toFixed(1));
      }

      return dataSets;
    },
    setDataBar(data) {
      let dataSets = data
        .filter((x) => x.SubGrupo)
        .map((x, k) => {
          return x["countData"]["sum"];
        });

      if (dataSets.length > 5) {
        // The elements from position 5 onwards are added together
        const startIndex = 5;
        const sumOfElements = dataSets
          .slice(startIndex)
          .reduce((a, b) => +a + +b, 0);
        // Set data
        dataSets = dataSets.slice(0, 5);
        dataSets.push(sumOfElements.toFixed(0));
      }

      return dataSets;
    },
    setLabelsDona(data) {
      if (data.length > 5) {
        data = data.slice(0, 5);
        data.push("Otros");
      }
      return data;
    },
    setLabelBar(data) {
      if (data.length > 5) {
        data = data.slice(0, 5);
        data.push("Otros");
      }
      return data;
    },
    selectGraph(data) {
      const targetDiv = document.getElementById(`Grafica-${data}`);
      targetDiv.scrollIntoViewPromise({ behavior: "smooth" }).then(() => {
        setTimeout(() => {
          targetDiv.classList.add("zoomed");
          setTimeout(() => {
            targetDiv.classList.remove("zoomed");
          }, 2000);
        }, 500);
      });
    },
    showMenu() {
      this.showMenuG = !this.showMenuG;
    },
    // Table
    showTable(data) {
      if (data === this.activeTable) {
        this.activeTable = "";
      } else {
        this.activeTable = data;
      }
    },
    getDataTable(data) {
      return data.map((e) => {
        return {
          label: e.SubGrupo,
          data: e["countData"]["sum"],
        };
      });
    },
  },
  created() {
    Element.prototype.scrollIntoViewPromise = function(options) {
      // "this" refers to the current element (el.scrollIntoViewPromise(options): this = el)
      this.scrollIntoView(options);

      // I create a variable that can be read inside the returned object ({ then: f() }) to expose the current element
      let parent = this;

      // I return an object with just a property inside called then
      // then contains a function which accept a function as parameter that will be execute when the scroll ends
      return {
        then: function(x) {
          // Check out https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API for more informations
          const intersectionObserver = new IntersectionObserver((entries) => {
            let [entry] = entries;

            // When the scroll ends (when our element is inside the screen)
            if (entry.isIntersecting) {
              // Execute the function into then parameter and stop observing the html element
              setTimeout(() => {
                x();
                intersectionObserver.unobserve(parent);
              }, 100);
            }
          });

          // I start to observe the element where I scrolled
          intersectionObserver.observe(parent);
        },
      };
    };
  },
  beforeDestroy() {
    delete Element.prototype.scrollIntoViewPromise;
  },
  watch: {
    "header.select": function(nv) {
      if (nv) {
        this.selectGraph(nv);
        this.header.select = "";
      }
    },
  },
  components: {
    yGraph,
    menuGraphsDemo,
    tableDemo,
  },
};
</script>

<style lang="scss">
.grid-container-graphs {
  display: grid;
  column-gap: 10px;
  @media (max-width: 769px) {
    grid-template-columns: auto;
  }
  grid-template-columns: 11rem auto;
}

.zoomed {
  animation: zoomAnimation 0.5s both; /* Duración de la animación de 0.5 segundos */
}

@keyframes zoomAnimation {
  0% {
    transform: scale(1); /* Estado inicial: escala normal */
  }
  50% {
    transform: scale(1.05); /* 50% de zoom */
  }
  100% {
    transform: scale(1); /* Estado final: escala normal */
  }
}

.slide-enter {
  transform: translateX(30vw);
}

.slide-enter-active {
  transition: all 0.3s ease-in;
}

.slide-leave-active {
  transition: all 0.3s ease-in;
}
.slide-leave-to {
  transform: translateX(30vw);
}

.slide-two-enter {
  transform: translateX(30vw);
}

.slide-two-enter-active {
  transition: all 0.3s ease-in;
}

.slide-two-leave-active {
  transition: all 0.3s ease-in;
}
.slide-two-leave-to {
  transform: translateX(30vw);
}

.button-menu {
  position: fixed;
  top: 0;
  padding: 15px;
  right: 0;
  transition: all 0.3s ease 0s;
  z-index: 61;
}
</style>



// WEBPACK FOOTER //
// src/components/frpm/Demographic.vue